<!--components\GeneralContent.vue-->
<template>
  <!-- CONTENIDO GENERAL -->
  <h1 v-if="seo" class="sr-only">{{ seo.h1 }}</h1>
  <DcLoadScreen v-if="paraTodos" />
  <Countdown v-if="paraTodos" />
  
  <CarruselPrincipalFix v-if="paraTodos" :key="`carrusel-principal-${modo_sistema}`"/>

  <FormularioCentralita v-if="paraTodos" />
  <IndicacionesFlujoCompras v-if="paraTodos" />
  <BotonesLaterales v-if="paraTodos" />

  <!-- FRENOS TOMARE COMO REFERENCIA ACEITES 
  <AsiFunciona v-if="paraFrenos" />
  <NuestrasMarcas v-if="paraFrenos" />
  <FrenosAdecuados v-if="paraFrenos" />
  <CardsInformativas v-if="paraFrenos" />-->
  <ConsejosFrenos v-if="paraFrenos" />
  <PreguntasFrecuentesFrenos v-if="paraFrenos" />
  <BannerRevisionFrenos v-if="paraFrenos" />
  
  <ResenasGrid v-if="paraFrenos" />
  <Locations v-if="paraFrenos" />
  <ServiciosIncluidos v-if="paraFrenos" />

  <!-- ACEITES -->
  <ComoFuncionaLubricantes v-if="paraAceites" />
  <MarcasAceites v-if="paraAceites" />
  <TuEsperaAceites v-if="paraAceites" />
  <TipsCambioAceites v-if="paraAceites" />
  <PersonasAceites v-if="paraAceites" />
  <Locations v-if="paraAceites" />
  <ServiciosIncluidos v-if="paraAceites" />
  <BannerTrabajadores v-if="paraAceites" />

  <!-- HOME -->
  <ServiciosGrid v-if="paraHome" />
  <NuestrasMarcas v-if="paraHome" />
  <ConoceServicios v-if="paraHome" />
  <VideosGrid v-if="paraHome" />
  <ServiciosIncluidos v-if="paraHome" />
  <SplitBanner v-if="paraHome" />
  <BestBrandHome v-if="paraHome" />
  <Guide v-if="paraHome" />
  <OfertasDestacadasGrid v-if="paraHome" />
  <ResenasGrid v-if="paraHome" />
  <Locations v-if="paraHome" />
  <BannerTrabajadores v-if="paraHome" />

  <!-- NEUMÁTICOS -->
  <ServiciosIncluidos v-if="paraNeumaticos" />
  <SplitBanner v-if="paraNeumaticos" />
  <BestBrandHome v-if="paraNeumaticos" />
  <NewProductGuide v-if="paraNeumaticos" />
  <Guide v-if="paraNeumaticos" />
  <TipsHome v-if="paraNeumaticos" />
  <Specification v-if="paraNeumaticos" />
  <SignalAwareness v-if="paraNeumaticos" />
  <CartasInformativas v-if="paraNeumaticos" />
  <ResenasGrid v-if="paraNeumaticos" />
  <Locations v-if="paraNeumaticos" />
  <OfertasDestacadasGrid v-if="paraNeumaticos" />
  <BannerTrabajadores v-if="paraNeumaticos" />

  <!-- BATERÍAS -->
  <BestBrandHome v-if="paraBaterias" />
  <ProductInfoBattery v-if="paraBaterias" />
  <Guide v-if="paraBaterias" />
  <TipsHome v-if="paraBaterias" />
  <VideosGrid v-if="paraBaterias" />
  <ResenasGrid v-if="paraBaterias" />
  <OfertasDestacadasGrid v-if="paraBaterias" />
  <Locations v-if="paraBaterias" />
  <ServiciosIncluidos v-if="paraBaterias" />
  <BannerTrabajadores v-if="paraBaterias" />

  <!-- AFINAMIENTO -->
  <SplitBanner v-if="paraAfinamiento" />
  <AsiFunciona v-if="paraAfinamiento" />
  <SeccionInformativaSplit v-if="paraAfinamiento" v-bind="configAfinamiento" />
  <SeccionServicios v-if="paraAfinamiento"/>
  <SeccionImportanciaAfinamiento v-if="paraAfinamiento" />
  <ResenasGrid v-if="paraAfinamiento" />
  <Locations v-if="paraAfinamiento" />
  <ServiciosIncluidos v-if="paraAfinamiento" />
  <BannerTrabajadores v-if="paraAfinamiento" />

  <!-- AMORTIGUADORES -->
  <SplitBanner v-if="paraAmortiguadores" />
  <AsiFunciona v-if="paraAmortiguadores" />
  <SeccionInformativaSplit v-if="paraAmortiguadores" v-bind="configAmortiguadores" />
  <SeccionInfoAmortiguadores v-if="paraAmortiguadores" />
  <ResenasGrid v-if="paraAmortiguadores" />
  <Locations v-if="paraAmortiguadores" />
  <ServiciosIncluidos v-if="paraAmortiguadores" />
  <BannerTrabajadores v-if="paraAmortiguadores" />

  <!-- ALINEACIÓN -->
  <SplitBanner v-if="paraAlineacion" />
  <AsiFunciona v-if="paraAlineacion" />
  <SeccionInformativaSplit v-if="paraAlineacion" v-bind="configAlineacion" />
  
  <EsImportante v-if="paraAlineacion" />
  <ComoPuedo v-if="paraAlineacion" />
  <Convergencia v-if="paraAlineacion" />
  <QuePasaSi v-if="paraAlineacion" />

  <ResenasGrid v-if="paraAlineacion" />
  <Locations v-if="paraAlineacion" />
  <ServiciosIncluidos v-if="paraAlineacion" />
  <BannerTrabajadores v-if="paraAlineacion" />

  <!-- BALANCEO -->
  <SplitBanner v-if="paraBalanceo" />
  <AsiFunciona v-if="paraBalanceo" />
  <SeccionInformativaSplit v-if="paraBalanceo" v-bind="configBalanceo" />
  <SeccionBalanceo v-if="paraBalanceo" />
  <ResenasGrid v-if="paraBalanceo" />
  <Locations v-if="paraBalanceo" />
  <ServiciosIncluidos v-if="paraBalanceo" />
  <BannerTrabajadores v-if="paraBalanceo" />

  <!-- GEOMETRIA -->
  <SplitBanner v-if="paraGeometria" />
  <AsiFunciona v-if="paraGeometria" />
  <SeccionInformativaSplit v-if="paraGeometria" v-bind="configGeometria" />
  <SeccionGeometria v-if="paraGeometria"/>
  <ResenasGrid v-if="paraGeometria" />
  <Locations v-if="paraGeometria" />
  <ServiciosIncluidos v-if="paraGeometria" />
  <BannerTrabajadores v-if="paraGeometria" />

  <!-- KILOMETRAJE -->
  <SplitBanner v-if="paraKilometraje" />
  <AsiFunciona v-if="paraKilometraje" />
  <SeccionInformativaSplit v-if="paraKilometraje" v-bind="configKilometraje" />
  <Kilometros v-if="paraKilometraje" />
  <ResenasGrid v-if="paraKilometraje" />
  <Locations v-if="paraKilometraje" />
  <ServiciosIncluidos v-if="paraKilometraje" />
  <BannerTrabajadores v-if="paraKilometraje" />

  <!-- HIGIENIZACIÓN -->
  <SplitBanner v-if="paraHigienizacion" />
  <AsiFunciona v-if="paraHigienizacion" />
  <SeccionInformativaSplit v-if="paraHigienizacion" v-bind="configHigienizacion" />
  <SeccionAireAcondicionado v-if="paraHigienizacion" />
  <ResenasGrid v-if="paraHigienizacion" />
  <Locations v-if="paraHigienizacion" />
  <ServiciosIncluidos v-if="paraHigienizacion" />
  <BannerTrabajadores v-if="paraHigienizacion" />

  <!-- FLUIDOS -->
  <SplitBanner v-if="paraFluidos" />
  <AsiFunciona v-if="paraFluidos" />
  <SeccionInformativaSplit v-if="paraFluidos" v-bind="configFluidos" />
  <Aditivos v-if="paraFluidos" />
  <ResenasGrid v-if="paraFluidos" />
  <Locations v-if="paraFluidos" />
  <ServiciosIncluidos v-if="paraFluidos" />
  <BannerTrabajadores v-if="paraFluidos" />

  <!-- ELÉCTRICO -->
  <SplitBanner v-if="paraElectrico" />
  <AsiFunciona v-if="paraElectrico" />
  <SeccionInformativaSplit v-if="paraElectrico" v-bind="configElectrico" />

  <MotorArranque v-if="paraElectrico" />
  <SistemaIluAutomotriz v-if="paraElectrico" />

  <SistemasIluminacion v-if="paraElectrico" />
  
  <Sistema1 v-if="paraElectrico" />
  
  <SistemaAudio v-if="paraElectrico" />
  <SistemaClima v-if="paraElectrico" />

  <TeHazPreguntado v-if="paraElectrico" />
  <Sistema v-if="paraElectrico" />
  <ResenasGrid v-if="paraElectrico" />
  <Locations v-if="paraElectrico" />
  <ServiciosIncluidos v-if="paraElectrico" />
  <BannerTrabajadores v-if="paraElectrico" />

  <!-- ACCESORIOS -->
  <SplitBanner v-if="paraAccesorios" />
  <MantenAuto v-if="paraAccesorios" />
  <IconosRepresentativos v-if="paraAccesorios" />
  <Extintores v-if="paraAccesorios" />
  <Plumillas v-if="paraAccesorios" />
  <Ampolletas v-if="paraAccesorios" />
  <ResenasGrid v-if="paraAccesorios" />
  <Locations v-if="paraAccesorios" />
  <ServiciosIncluidos v-if="paraAccesorios" />
  <BannerTrabajadores v-if="paraAccesorios" />

  <!-- TREN DELANTERO -->
  <SplitBanner v-if="paraTrenDelantero" />
  <AsiFunciona v-if="paraTrenDelantero" />
  <SeccionInformativaSplit v-if="paraTrenDelantero" v-bind="configTrenDelantero" />
  <SeccionDireccion v-if="paraTrenDelantero" />
  <ResenasGrid v-if="paraTrenDelantero" />
  <Locations v-if="paraTrenDelantero" />
  <ServiciosIncluidos v-if="paraTrenDelantero" />
  <BannerTrabajadores v-if="paraTrenDelantero" />

  <!--  REVISIÓN TÉCNICA -->  
  <SplitBanner v-if="paraRevisionTecnica" />
  <AsiFunciona v-if="paraRevisionTecnica" />
  <RevisionTecnicaInfoSections v-if="paraRevisionTecnica" />
  <ResenasGrid v-if="paraRevisionTecnica" />
  <Locations v-if="paraRevisionTecnica" />
  <ServiciosIncluidos v-if="paraRevisionTecnica" />
  <BannerTrabajadores v-if="paraRevisionTecnica" />

  <!-- PanelBoletas -->
  <PanelBoletas v-if="paraBoletas"/>

  <!-- POPUP -->
  <Popupavisos ref="popupavisos_ref" />
</template>

<script setup>
// VUE - NUXT
import { computed, ref, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'

// COMPONENTES UI GENERALES
import DcLoadScreen from '~/components/Ui/DcLoadScreen.vue'
import BotonesLaterales from '~/components/Ui/BotonesLaterales.vue'
import Countdown from '~/components/Countdown.vue'
import CarruselPrincipalFix from '~/components/Carruseles/CarruselPrincipalFix.vue'
import FormularioCentralita from '~/components/Formularios/FormularioCentralita.vue'
import IndicacionesFlujoCompras from '~/components/Home/IndicacionesFlujoCompras.vue'
import AsiFunciona from '~/components/Comunes/AsiFunciona.vue'
import SeccionInformativaSplit from '~/components/Comunes/SeccionInformativaSplit.vue'

// ACEITES
import ComoFuncionaLubricantes from '~/components/Aceites/ComoFuncionaLubricantes.vue'
import MarcasAceites from '~/components/Aceites/MarcasAceites.vue'
import TuEsperaAceites from '~/components/Aceites/TuEsperaAceites.vue'
import TipsCambioAceites from '~/components/Aceites/TipsCambioAceites.vue'
import PersonasAceites from '~/components/Aceites/PersonasAceites.vue'
import NuestrasMarcas from '~/components/Carruseles/NuestrasMarcas.vue'

// FRENOS
import FrenosAdecuados from '~/components/Frenos/FrenosAdecuados.vue'
import CardsInformativas from '~/components/Frenos/CardsInformativas.vue'
import BannerRevisionFrenos from '~/components/Frenos/BannerRevisionFrenos.vue'
import ConsejosFrenos from '~/components/Frenos/ConsejosFrenos.vue'
import PreguntasFrecuentesFrenos from '~/components/Frenos/PreguntasFrecuentesFrenos.vue'


// HOME
import ServiciosGrid from '~/components/newhome/servicios/ServiciosGrid.vue'
import ConoceServicios from '~/components/newhome/servicios/ConoceServicios.vue'
import SplitBanner from '~/components/newhome/split-banner/SplitBanner.vue'
import OfertasDestacadasGrid from '~/components/newhome/ofertas-destacadas/OfertasDestacadasGrid.vue'
import VideosGrid from '~/components/newhome/resenas/VideosGrid.vue'
import ResenasGrid from '~/components/newhome/resenas/ResenasGrid.vue'
import BannerTrabajadores from '~/components/Home/banners/BannerTrabajadores.vue'
import ServiciosIncluidos from '~/components/Home/servicios/ServiciosIncluidos.vue'
import Guide from '~/components/Home/Guide.vue'
import BestBrandHome from '~/components/Home/BestBrandHome.vue'
import Locations from '~/components/Home/Locations.vue'
import TipsHome from '~/components/Home/TipsHome.vue'

// NEUMÁTICOS
import NewProductGuide from '~/components/Home/Tire/NewProductGuide.vue'
import Specification from '~/components/Home/Specification.vue'
import SignalAwareness from '~/components/Home/Tire/SignalAwareness.vue'
import CartasInformativas from '~/components/Cards/CartasInformativas.vue'

// Accesorios
import MantenAuto from '~/components/Accesorios/MantenAuto.vue'
import IconosRepresentativos from '~/components/Accesorios/IconosRepresentativos.vue'
import Extintores from '~/components/Accesorios/Extintores.vue'
import Plumillas from '~/components/Accesorios/Plumillas.vue'
import Ampolletas from '~/components/Accesorios/Ampolletas.vue'

// BATERÍAS
import ProductInfoBattery from '~/components/Home/Battery/ProductInfoBattery.vue'

// AFINAMIENTO
import SeccionServicios from './Afinamiento/SeccionServicios.vue'
import SeccionImportanciaAfinamiento from '@/components/Afinamiento/SeccionImportanciaAfinamiento.vue';

// KILOMETROS
import Kilometros from '~/components/Kilometraje/Kilometros.vue';

// BALANCEO
import SeccionBalanceo from './Balanceo/SeccionBalanceo.vue'

// GEOMETRIA
import SeccionGeometria from './Geometria/SeccionGeometria.vue'

// HIGIENIZACION
import SeccionAireAcondicionado from './Higienizacion/SeccionAireAcondicionado.vue'

// Alineacion
import ComoPuedo from '~/components/Alineacion/ComoPuedo.vue'
import EsImportante from '~/components/Alineacion/EsImportante.vue'
import Convergencia from '~/components/Alineacion/Convergencia.vue'
import QuePasaSi from '~/components/Alineacion/QuePasaSi.vue'

// FLUIDOS
import Aditivos from './Fluidos/Aditivos.vue'

// TREN DELANTERO
import SeccionDireccion from './Trendelantero/SeccionDireccion.vue'

// AMORTIGUADORES
import SeccionInfoAmortiguadores from './Amortiguadores/SeccionInfoAmortiguadores.vue'

// Electrico
import MotorArranque from '~/components/Electrico/MotorArranque.vue'
import SistemaIluAutomotriz from '~/components/Electrico/SistemaIluAutomotriz.vue'

import SistemaAudio from '~/components/Electrico/SistemaAudio.vue'
import SistemaClima from '~/components/Electrico/SistemaClima.vue'
import Sistema from '~/components/Electrico/Sistema.vue'
import Sistema1 from '~/components/Electrico/Sistema1.vue'
import TeHazPreguntado from '~/components/Electrico/TeHazPreguntado.vue'

import SistemasIluminacion from '~/components/Electrico/SistemasIluminacion.vue'

// REVISION TECNICA
import RevisionTecnicaInfoSections from '~/components/RevisionTecnica/RevisionTecnicaInfoSections.vue'

// Boletas
import PanelBoletas from '~/components/Boletas/PanelBoletas.vue'

// POPUP
import Popupavisos from '~/components/Popups/Popupavisos.vue'

// CONSTANTES / CONFIG
import { NEGOCIOS, COMPLEMENTARIOS } from '~/constants/negocios'
import { aliasSistemas } from '@/constants/aliasSistemas'

// STATE / STORE
const modo_sistema = useState('modo_sistema')
const { seo } = useMappedSeo()
const store = useStore()
const popupavisos_ref = ref(null)

// COMPUTED FLAGS
const paraHome = computed(() => modo_sistema.value === NEGOCIOS.HOME)
const paraNeumaticos = computed(() => modo_sistema.value === NEGOCIOS.NEUMATICOS)
const paraBaterias = computed(() => modo_sistema.value === NEGOCIOS.BATERIAS)
const paraAceites = computed(() => modo_sistema.value === NEGOCIOS.ACEITES)
const paraFrenos = computed(() => modo_sistema.value === NEGOCIOS.FRENOS)
const paraAfinamiento = computed(() => modo_sistema.value === NEGOCIOS.AFINAMIENTO)
const paraAmortiguadores = computed(() => modo_sistema.value === NEGOCIOS.AMORTIGUADORES)
const paraAlineacion = computed(() => modo_sistema.value === NEGOCIOS.ALINEACION)
const paraBalanceo = computed(() => modo_sistema.value === NEGOCIOS.BALANCEO)
const paraGeometria = computed(() => modo_sistema.value === NEGOCIOS.GEOMETRIA)
const paraKilometraje = computed(() => modo_sistema.value === NEGOCIOS.KILOMETRAJE)
const paraHigienizacion = computed(() => modo_sistema.value === NEGOCIOS.HIGIENIZACION)
const paraFluidos = computed(() => modo_sistema.value === NEGOCIOS.FLUIDOS)
const paraElectrico = computed(() => modo_sistema.value === NEGOCIOS.ELECTRICO)
const paraAccesorios = computed(() => modo_sistema.value === NEGOCIOS.ACCESORIOS)
const paraTrenDelantero = computed(() => modo_sistema.value === NEGOCIOS.TRENDELANTERO)
const paraRevisionTecnica = computed(() => modo_sistema.value === NEGOCIOS.REVISIONTECNICA)

const paraBoletas = computed(() => modo_sistema.value === COMPLEMENTARIOS.BOLETAS)

const paraTodos = computed(() => Object.values(NEGOCIOS).includes(modo_sistema.value))


// CONFIGURACIONES DE SECCIONES
const configAfinamiento = {
  titulo: "AFINAMIENTO",
  parrafos: [
    'Realizar este servicio permite que el auto consuma menos combustible, que el motor se desempeñe mejor y reducir la emisión de gases contaminantes. Esta mantención consiste básicamente en cambio de bujías, filtros de aire y de bencina y se recomienda siempre realizar una limpieza de inyectores. Todo ello garantiza alargar la vida útil del motor, obtener un buen rendimiento en consumo de gasolina o diesel, mayor potencia y un andar parejo. El análisis de gases es uno de los ítems más chequeados para obtener la Revisión Técnica, por lo que te sugerimos verificar la emisión de éstos antes de llevar tu auto a la planta.'
  ],
  fondo_derecho_url: "/img/afinamiento/fondo_afinamiento.jpg",
  imagen_superpuesta_url: "/img/afinamiento/motor.png",
  imagen_superpuesta_alt: "AFINAMIENTO",
  imagen_superpuesta_clases: "right-[-2%] top-[52%] w-[88%]",
  imagen_superpuesta_estilo_desktop: {
    left: '-6%',
    top: '50%',
    width: '62%',
    transform: 'translateY(-50%)'
  }
}

const configAmortiguadores = {
  titulo: "AMORTIGUADORES",
  parrafos: [
    'El sistema de suspensión del vehículo se encarga de controlar el comportamiento de las ruedas en contacto con el suelo. Dentro de este sistema, el elemento más importante son los amortiguadores. Éstos proporcionan seguridad, estabilidad y confort durante la conducción. Cuando los amortiguadores fallan, el vehículo pierde estabilidad, se produce un menor efecto de frenado y los neumáticos se desgastan en forma dispareja.',
    'El amortiguador forma parte del sistema de suspensión juntamente con el resorte, los brazos y las rótulas, entre otros elementos. Básicamente, el amortiguador controla las oscilaciones de la suspensión para que ésta no rebote en exceso y el neumático pierda contacto con la superficie. Ello redunda en un mejor agarre en curva, reducción de distancia de frenado y, además, una mayor suavidad en la conducción.',
    'Es importante buscar un equilibrio entre rigidez y flexibilidad en la amortiguación, para asegurar un buen agarre del neumático, al mismo tiempo que una suavidad en el manejo. Por ello, es fundamental sustituir el amortiguador cuando haya perdido sus propiedades con el paso de los kilómetros.'
  ],
  fondo_derecho_url: "/img/amortiguadores/fondo_negro.jpg",
  imagen_superpuesta_url: "/img/amortiguadores/amortiguador.png",
  imagen_superpuesta_alt: "AMORTIGUADOR",
  imagen_superpuesta_clases: "right-[-2%] top-[52%] w-[88%]",
  imagen_superpuesta_estilo_desktop: {
    left: '-6%',
    top: '50%',
    width: '62%',
    transform: 'translateY(-50%)'
  }
}

const configAlineacion = {
  titulo: "ALINEACIÓN",
  parrafos: [
    'El servicio de un auto se refiere a todos los componentes eléctricos que hacen funcionar el vehículo, como la batería, el motor de arranque, el alternador, el sistema de iluminación, el sistema de sonido, entre otros. La batería es uno de los componentes más importantes del sistema eléctrico de un auto, ya que es la encargada de proporcionar la energía eléctrica necesaria para el arranque del motor y para alimentar los sistemas eléctricos del vehículo cuando el motor está apagado. El alternador, por otro lado, es el encargado de cargar la batería y proporcionar energía eléctrica al sistema cuando el motor está en marcha.'
  ],
  fondo_izquierdo_url: "/img/alineacion/fondo_rojo.jpg",
  fondo_derecho_url: "/img/alineacion/fondo_negro.jpg",
  imagen_superpuesta_url: "/img/alineacion/Neuma1.png",
  imagen_superpuesta_alt: "ALINEACIÓN",
  imagen_superpuesta_clases: "right-[-2%] top-[52%] w-[88%]",
  imagen_superpuesta_estilo_desktop: {
    left: '-6%',
    top: '50%',
    width: '62%',
    transform: 'translateY(-50%)'
  }
}

const configBalanceo = {
  titulo: "BALANCEO",
  parrafos: [
    'Si el volante vibra o tu auto tiene ruidos a determinadas velocidades, es preciso que verifiques el balanceo de las ruedas de tu auto. El balanceo previene el desgaste prematuro de la suspensión y rodamiento de los ejes y los neumáticos.',
    'A continuación, te explicamos todo lo que debes saber acerca de este servicio.'
  ],
  fondo_izquierdo_url: "/img/balanceo/fondo_rojo.jpg",
  fondo_derecho_url: "/img/balanceo/fondo_negro.jpg",
  imagen_superpuesta_url: "/img/balanceo/RecorteRueda.png",
  imagen_superpuesta_alt: "BALANCEO",
  imagen_superpuesta_clases: "right-[-2%] top-[52%] w-[88%]",
  imagen_superpuesta_estilo_desktop: {
    left: '-6%',
    top: '50%',
    width: '62%',
    transform: 'translateY(-50%)'
  }
}

const configGeometria = {
  titulo: "GEOMETRÍA AUTOMOTRIZ",
  parrafos: [
    'El servicio de geometría automotriz es un procedimiento en el que se ajustan los ángulos de las ruedas de un vehículo para asegurar que estén alineadas correctamente y en la posición adecuada en relación al chasis y al camino.',
    'Es necesario realizarlo para mejorar el rendimiento del vehículo, evitar el desgaste irregular de los neumáticos y garantizar una conducción segura y cómoda. El proceso de geometría automotriz implica la medición y ajuste de varios ángulos, como el ángulo de convergencia, de caída, de avance y de la dirección.'
  ],
  fondo_izquierdo_url: "/img/geometria/fondo_rojo.jpg",
  fondo_derecho_url: "/img/geometria/fondo_negro.png"
}

const configKilometraje = {
  titulo: "REVISIÓN DE KILOMETRAJE",
  parrafos: [
    'Siempre escuchamos que es necesario realizar la revisión de kilometraje para hacer una mantención preventiva del auto.',
    'Según la distancia recorrida, es necesario revisar diferentes piezas del vehículo y realizar algunos servicios.',
    'En LEÓN nos preocupamos por tu seguridad. A continuación, te detallamos la lista de cosas que se deben chequear, según el kilometraje del auto.',
    'Esto es una idea general. En ningún caso efectuaremos algún trabajo sin consultar el manual de marca del vehículo. Así, nos aseguraremos de realizar lo que recomienda el fabricante.'
    //'De todas maneras, en todas nuestras sucursales contamos con una revisión de seguridad gratuita, en la cual entregamos un informe del estado del vehículo.'
  ],
  fondo_izquierdo_url: "/img/kilometraje/fondo_rojo.jpg",
  fondo_derecho_url: "/img/kilometraje/fondo_negro.jpg",
  imagen_superpuesta_url: "/img/kilometraje/sinoptico.png",
  imagen_superpuesta_alt: "REVISIÓN DE KILOMETRAJE",
  imagen_superpuesta_clases: "right-[-2%] top-[52%] w-[88%]",
  imagen_superpuesta_estilo_desktop: {
    left: '-6%',
    top: '50%',
    width: '62%',
    transform: 'translateY(-50%)'
  }
}

const configHigienizacion = {
  titulo: "HIGIENIZACIÓN",
  parrafos: [
    'Si al encender el aire acondicionado de tu auto sale olor a humedad y se demora en enfriar, es hora de hacerle una mantención. La higienización de un automóvil es crucial para garantizar la salud y la seguridad de los pasajeros. Es necesario limpiar y desinfectar el sistema de aire acondicionado regularmente para eliminar gérmenes, bacterias y virus que puedan estar presentes en el interior. Ello ayuda a prevenir los malos olores y la acumulación de moho.'
  ],
  fondo_izquierdo_url: "/img/higienizacion/fondo_rojo.jpg",
  fondo_derecho_url: "/img/higienizacion/fondo_negro.jpg"
}

const configFluidos = {
  titulo: "FLUIDOS",
  parrafos: [
    'Los vehículos cuentan con numerosos fluidos, cuya función es ofrecer un buen rendimiento del auto en condiciones extremas. Los aditivos se añaden a estos fluidos para mejorar, optimizar o alargar sus prestaciones y las de determinadas partes del auto.'
  ],
  fondo_izquierdo_url: "/img/fluidos/fondo_rojo.jpg",
  fondo_derecho_url: "/img/fluidos/fondo_negro.png"
}

const configElectrico = {
  titulo: "Sistema eléctrico",
  parrafos: [
    'El servicio de un auto se refiere a todos los componentes eléctricos que hacen funcionar el vehículo, como la batería, el motor de arranque, el alternador, el sistema de iluminación, el sistema de sonido, entre otros. La batería es uno de los componentes más importantes del sistema eléctrico de un auto, ya que es la encargada de proporcionar la energía eléctrica necesaria para el arranque del motor y para alimentar los sistemas eléctricos del vehículo cuando el motor está apagado. El alternador, por otro lado, es el encargado de cargar la batería y proporcionar energía eléctrica al sistema cuando el motor está en marcha.'
  ],
  fondo_izquierdo_url: "/img/electrico/fondo_rojo.jpg",
  fondo_derecho_url: "/img/electrico/fondo_negro.jpg",
  imagen_superpuesta_url: "/img/electrico/sistema-electrico.png",
  imagen_superpuesta_alt: "TREN DELANTERO",
  imagen_superpuesta_clases: "right-[-2%] top-[52%] w-[88%]",
  imagen_superpuesta_estilo_desktop: {
    left: '-6%',
    top: '50%',
    width: '62%',
    transform: 'translateY(-50%)'
  }
}

const configTrenDelantero = {
  titulo: "TREN DELANTERO",
  parrafos: [
    'El tren delantero juega una función muy importante en el manejo y conducción de cualquier automóvil; por lo tanto es vital mantener constante supervisión en el mismo.',
    'El tren delantero son todos los elementos que se encuentran en la parte delantera del vehículo, tales cómo: el sistema de suspensión, el sistema de frenos y el mecanismo de dirección. La conducción segura, la capacidad de respuesta de la dirección y el frenado rápido están en peligro si no se tiene un buen conocimiento y un buen mantenimiento sobre el tren delantero',
    'El grupo de piezas que llamamos tren delantero o ensamblaje frontal incluye tanto el sistema de dirección como el sistema de suspensión del vehículo. La estructura debe ser hermética, sólida y segura, con componentes metálicos y blandos en buenas condiciones.'
  ],
  fondo_izquierdo_url: "/img/trendelantero/fondo_rojo.jpg",
  fondo_derecho_url: "/img/trendelantero/fondo_negro.jpg",
  imagen_superpuesta_url: "/img/trendelantero/Suspension-delantera.png",
  imagen_superpuesta_alt: "TREN DELANTERO",
  imagen_superpuesta_clases: "right-[-2%] top-[52%] w-[88%]",
  imagen_superpuesta_estilo_desktop: {
    left: '-6%',
    top: '50%',
    width: '62%',
    transform: 'translateY(-50%)'
  }
}

const configRevisionTecnica = {
  titulo: 'REVISIÓN TÉCNICA',
  parrafos: [
    'En LEÓN te ayudamos a gestionar tu revisión técnica con un flujo de agendamiento alineado al resto de nuestros servicios.',
    'Podrás elegir local, revisar disponibilidad y dejar coordinado tu servicio manteniendo la misma experiencia visual y operativa de los demás agendadores.',
    'La gestión considera la revisión del vehículo, la coordinación con la sucursal y el registro formal del agendamiento dentro del ecosistema del backoffice.'
  ],
  fondo_izquierdo_url: '/img/trendelantero/fondo_rojo.jpg',
  fondo_derecho_url: '/img/trendelantero/fondo_negro.jpg',
  imagen_superpuesta_url: '/img/trendelantero/Suspension-delantera.png',
  imagen_superpuesta_alt: 'REVISIÓN TÉCNICA',
  imagen_superpuesta_clases: 'right-[-2%] top-[52%] w-[88%]',
  imagen_superpuesta_estilo_desktop: {
    left: '-6%',
    top: '50%',
    width: '62%',
    transform: 'translateY(-50%)'
  }
}

// DEBUG
const config = useRuntimeConfig()
const debug = {
  enabled: config.public.modo === 'DEV',
  log: (...args) => debug.enabled && console.log(...args),
  error: (...args) => debug.enabled && console.error(...args),
}

// POPUP LOGIC
// POPUP LOGIC
const cargarPopup = async () => {
  try {
    const yaMostrado = store.getters['comunes/getPopupAvisoMostrado']

    if (yaMostrado) {
      debug.log('Popup ya mostrado en esta sesión')
      return
    }

    const alias = aliasSistemas[modo_sistema.value]
    if (!alias) return

    const response = await $fetch('/api/mantenedores-visuales', {
      query: { action: 'popups', alias }
    })

    if (response.status === 'success' && response.data?.url_popup_desktop) {
      popupavisos_ref.value?.openPopup(response.data.url_popup_desktop)
      store.commit('comunes/setPopupAvisoMostrado')
    }
  } catch (err) {
    debug.error('Popup no disponible (404 esperado):', err)
  }
}

// LIFECYCLE
onMounted(() => {
  store.commit('comunes/cargarStorage')
  nextTick(cargarPopup)
})

</script>
